const state = {
    tags: [
        {
            name: 'Learning Plus',
            handle: 'learning_plus',
        },
        {
            name: 'Enterprise',
            handle: 'enterprise',
        },
        {
            name: 'Restart',
            handle: 'restart',
        },
        {
            name: 'Skills',
            handle: 'skills',
        },
        {
            name: 'New Enterprise Allowance',
            handle: 'nea',
        },
        {
            name: 'IRC Hasockfield',
            handle: 'irc_hasockfield',
        },
        {
            name: 'Company Logos',
            handle: 'company_logos',
        },
        {
            name: 'Awarding Body Logo Display',
            handle: 'awarding_body_logo_display',
        },
        {
            name: 'Unpublished',
            handle: 'unpublished',
        },
    ],
};

const getters = {
    tags: state => {
        return state.tags;
    },
};

const actions = {};
const mutations = {};

export default {
    state,
    getters,
    actions,
    mutations,
};